import styled, { css } from 'styled-components';
import { variant } from 'styled-system';

import { boxShadow, getBoxShadow } from '../../../../atoms';

import { ThemeUtilities } from '../../../../../theme';
import { Variant } from '../../types';

export const Content = styled.div<{ bodyVariant?: Variant }>`
  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Card', 'bodyVariant'))};
`;

export const Wrapper = styled.div`
  overflow: auto;
  position: relative;
`;

export const BoxShadow = styled.div<{
  boxShadow: ReturnType<typeof getBoxShadow>;
}>`
  position: sticky;
  z-index: 1;
  left: 0;
  width: 100%;
  height: 6px;

  ${boxShadow};
  ${({ boxShadow }) =>
    boxShadow === 'top' &&
    css`
      top: 0;
    `};
  ${({ boxShadow }) =>
    boxShadow === 'bottom' &&
    css`
      bottom: 0;
    `};
`;
